import * as React from 'react';
import buildOmexConsentUrl from '../utils/buildOmexConsentUrl';
import OmexMessageType from '../schema/OmexMessageType';
import OmexResponse from '../schema/OmexResponse';
import onOmexConsentMessage from '../utils/onOmexConsentMessage';
import { observer } from 'mobx-react';
import {
    getAddinCommandForControl,
    getSsoDialog,
    updateSsoDialogVisibility,
} from 'owa-addins-store';

let styles = require('./SsoDialogStyles.scss');

export interface SsoOmexConsentDialogProps {
    userCulture: string;
    owaVersion: string;
}

@observer
export default class SsoOmexConsentDialog extends React.Component<SsoOmexConsentDialogProps, any> {
    refcallback = (iframeElement: HTMLIFrameElement): void => {
        const messageHandler = function(event: any) {
            if (!iframeElement || event.source != iframeElement.contentWindow) {
                return;
            }

            const message = JSON.parse(event.data) as OmexResponse;

            if (message.messageType == OmexMessageType.ConsentResult) {
                window.removeEventListener('message', messageHandler);
                onOmexConsentMessage(message.messageValue);
            } else if (message.messageType == OmexMessageType.PageLoad) {
                updateSsoDialogVisibility(/*isVisible*/ true);
            }
        };

        window.addEventListener('message', messageHandler);
        if (iframeElement != null && iframeElement.contentWindow != null) {
            iframeElement.contentWindow.focus();
        }
    };

    render(): JSX.Element {
        const dialog = getSsoDialog();
        const addinCommand = getAddinCommandForControl(dialog.controlId);
        const consentUrl = buildOmexConsentUrl(
            addinCommand,
            this.props.userCulture,
            this.props.owaVersion
        );
        return (
            <div>
                <iframe
                    src={consentUrl}
                    frameBorder="0"
                    className={styles.consentContainer}
                    ref={this.refcallback}
                />
            </div>
        );
    }
}
